<template>
  <section>
    <div class="row">
      <div class="col-12">
        <h4>Destinatarios</h4>
        <p>{{$t('lm_recipients_subtitle')}}</p>
      </div>
      <div class="wrapper-content px-3">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  label="Usuarios"
                  clearable
                  pathToGetOptions="/users/all"
                  v-model="recipientsData.users"
                />
                <LmButton
                  :disabled="!recipientsData.users"
                  buttonClass="btn-primary"
                  @click="onAddRecipient('users')"
                  :value="$t('add')"
                />
              </div>
              <div v-if="enableAreasAsRecipients" class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  label="Áreas"
                  clearable
                  pathToGetOptions="/customer/areas"
                  v-model="recipientsData.areas"
                  @input="clearSubAreas"
                />
                <LmButton
                  :disabled="!recipientsData.areas"
                  buttonClass="btn-primary"
                  @click="onAddRecipient('areas')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  v-if="!enableAreasAsRecipients"
                  class="mr-4"
                  label="Áreas"
                  clearable
                  pathToGetOptions="/customer/areas"
                  v-model="recipientsData.areas"
                  @input="clearSubAreas"
                />
                <LmTreeSelect
                  class="mr-4"
                  :disabled="!(!!recipientsData.areas)"
                  label="Subáreas"
                  clearable
                  :pathToGetOptions="subareaOptions"
                  v-model="recipientsData.subareas"
                />
                <LmButton
                  :disabled="!recipientsData.subareas"
                  buttonClass="btn-primary"
                  @click="onAddRecipient('subareas')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  label="Grupos"
                  clearable
                  pathToGetOptions="/customer/groups"
                  v-model="recipientsData.groups"
                />
                <LmButton
                  :disabled="!recipientsData.groups"
                  buttonClass="btn-primary"
                  @click="onAddRecipient('groups')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-12 d-flex align-items-end mb-4" v-if="canAddExternalRecipients">
                <div class="w-100 pr-4">
                  <LmTagsInput
                    class="mb-0"
                    label="Emails"
                    v-model="recipientsData.emails"
                    :v="$v.recipientsData.emails"
                    placeholder="Ingresa emails destinatarios"
                  />
                </div>
                <LmButton
                  buttonClass="btn-primary"
                  :disabled="$v.recipientsData.emails.$invalid || !(!!recipientsData.emails.length)"
                  @click="onAddRecipient('emails')"
                  class="mb-0"
                  :value="$t('add')"
                />
              </div>
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="recipients.length">
                <b-list-group-item v-for="(recipient, index) of recipients" :key="index">
                  <div class="d-flex align-items-center">
                    <i
                      style="font-size: 20px"
                      class="mr-2 mdi"
                      :class="`mdi-${recipient.icon}`"
                    />
                    <span class="flex-grow-1">
                      {{ recipient.name }}
                    </span>
                    <i
                      style="font-size: 20px"
                      class="mr-2 clickable mdi mdi-close"
                      @click="onDeleteRecipient(recipient)"
                    />
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado destinatarios para este documento.
                </p>
              </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTagsInput from '@/components/form/elements/LmTagsInput'
import lmToasts from '@/mixins/lmToasts.js'

import { email } from 'vuelidate/lib/validators'
import { nanoid } from 'nanoid'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmButton,
    LmTagsInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    canAddExternalRecipients: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      recipientsData: {
        users: null,
        areas: null,
        subareas: null,
        groups: null,
        emails: []
      }
    }
  },
  validations: {
    recipientsData: {
      emails: {
        $each: {
          email
        }
      }
    }
  },
  computed: {
    recipients () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setRecipientIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    },
    subareaOptions () {
      if (this.recipientsData?.areas?.id) {
        return `/customer/subareas/${this.recipientsData.areas.id}`
      }
      return null
    },
    enableAreasAsRecipients () {
      return !(process.env?.VUE_APP_ENABLE_AREAS_AS_RECIPIENTS === 'no')
    }
  },
  methods: {
    validateEmailTag (event) {
      return email(event)
    },
    setRecipientIcon (type) {
      const icons = {
        users: 'account',
        areas: 'domain',
        subareas: 'account-group',
        groups: 'account-multiple',
        emails: 'at'
      }
      return icons[type]
    },
    clearData (prop) {
      if (prop === 'emails') {
        this.recipientsData[prop] = []
      } else {
        this.recipientsData[prop] = null
      }
    },
    onDeleteRecipient (recipient) {
      this.value[recipient.group] = this.value[recipient.group].filter(item => item.id !== recipient.id)
    },
    onAddRecipient (type) {
      if (type === 'emails') {
        this.recipientsData[type] = this.recipientsData[type].filter(el => !this.value[type].some(val => val.name === el))
      } else {
        if (this.value[type].some(val => val.id === this.recipientsData[type].id)) {
          this.clearData(type)
          this.lmToastDangerMessage('No se agregaron los destinatarios duplicados.', 'Destinatario duplicado')
          return
        }
      }

      if (Array.isArray(this.recipientsData[type])) {
        this.recipientsData[type].forEach(el => {
          if (typeof el === 'string') {
            el = {
              id: nanoid(5),
              name: el
            }
          }
          this.value[type].push(el)
        })
      } else {
        this.value[type].push(this.recipientsData[type])
      }
      this.clearData(type)
    },
    clearSubAreas () {
      if (this.recipientsData.subareas) {
        this.recipientsData.subareas = null
      }
    }
  }
}
</script>
